import React, { type ComponentType } from 'react';
import { ExperienceStart } from '@atlassian/jira-business-experience-tracking/src/controllers/experience-tracker/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import {
	fireUIAnalytics,
	useAnalyticsEvents,
	ContextualAnalyticsData,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import type { ExportTableProps } from '@atlassian/jira-software-roadmap-image-export/src/export/types.tsx';
import type { APIProps as ExportModalProps } from '@atlassian/jira-software-roadmap-image-export/src/modal/types.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { EXPORT_IMAGE_EXPERIENCE } from '../../../../common/constants.tsx';
import { LazySharingExport } from './export-share/async.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncSharingModal = lazy<ComponentType<ExportModalProps>>(
	() =>
		import(
			/* webpackChunkName: "async-roadmap-share-modal" */ '@atlassian/jira-software-roadmap-image-export/src/modal'
		),
	{ ssr: false },
);

type Props = {
	open: boolean;
	onOpenChange: (isOpen: boolean) => void;
	tableProps: ExportTableProps;
};

export const ExportImageModal = ({ open, onOpenChange, tableProps }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<>
			{open && (
				<ContextualAnalyticsData sourceName="exportImageShare" sourceType={MODAL}>
					<ExperienceStart experience={EXPORT_IMAGE_EXPERIENCE} />

					<Placeholder name="sharing-modal" fallback={null}>
						<AsyncSharingModal
							ExportImage={LazySharingExport}
							tableProps={tableProps}
							onClickDownload={(_, analyticsEvent) => {
								fireUIAnalytics(analyticsEvent, 'saveImageButton');
							}}
							onClose={() => {
								fireUIAnalytics(createAnalyticsEvent({}), 'exportImageShare closed');
								onOpenChange(false);
							}}
						/>
					</Placeholder>
				</ContextualAnalyticsData>
			)}
		</>
	);
};
